module.exports = __webpack_public_path__ + "img/icon-hz.5916422c.png";